import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-heading__inner" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "page-heading__title" }
const _hoisted_4 = { class: "breadcrumb page-heading__breadcrumb" }
const _hoisted_5 = /*#__PURE__*/_createVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createVNode("a", { href: "/" }, "Home")
], -1)
const _hoisted_6 = { class: "breadcrumb-item active" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    class: ["page-heading jarallax", _ctx.image]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("h1", _hoisted_3, _toDisplayString(_ctx.title), 1),
        _createVNode("ol", _hoisted_4, [
          _hoisted_5,
          _createVNode("li", _hoisted_6, _toDisplayString(_ctx.title), 1)
        ])
      ])
    ])
  ], 2))
}